import api from './axios';

export const listProducts = () => api.get('/products').then((r) => r.data);

// Server-side search + pagination — see listCustomersPage for why this can't be a
// client-side filter over a fetched page.
export const listProductsPage = ({ page = 1, limit = 50, search = '' } = {}) =>
  api.get('/products', { params: { page, limit, search } }).then((r) => ({
    items: r.data,
    total: Number(r.headers['x-total-count'] ?? r.data.length),
  }));
export const createProduct = (data) => api.post('/products', data).then((r) => r.data);
export const updateProduct = (id, data) => api.put(`/products/${id}`, data).then((r) => r.data);
export const deleteProduct = (id) => api.delete(`/products/${id}`).then((r) => r.data);
export const bulkUploadProducts = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/products/bulk-upload', formData).then((r) => r.data);
};
